import http from '~/common/http'
import Function from '~/common/functions'

//校网通日志列表
function index(params){
    return http.get('/api/product/recorder-ztcdown', {params:params})
}

//组卷日志列表
function zj_log(params) {
    return http.get('/api/product/zujuan', {params:params})
}

//组卷下载日志列表
function zj_down_log(params) {
    return http.get('/api/product/zujuan/down-log', {params:params})
}

//组卷下载日志列表
function zj_down_log_count_bar(params) {
    return http.get('/api/product/zujuan/down-log-count-bar', {params:params})
}

//组卷下载日志点数统计
function zj_down_count_point(params){
    return http.get('/api/product/zujuan/down-count', {params:params})
}

//组卷测试日志列表
function zj_test_log(params) {
    return http.get('/api/product/zujuan/test-log', {params:params})
}

//组卷作业日志列表
function zj_work_log(params) {
    return http.get('/api/product/zujuan/task-log', {params:params})
}

//校本资源库2下载日志列表
function jb_down_log(params) {
    return http.get('/api/product/jb/index', {params:params})
}

//新校本资源库下载日志列表
function jb3_down_log(params) {
    return http.get('/api/product/jb3/index', {params:params})
}

export default {
    index,
    zj_log,
    zj_down_log,
    zj_test_log,
    zj_work_log,
    zj_down_count_point,
    jb_down_log,
    jb3_down_log,
    zj_down_log_count_bar
}


// WEBPACK FOOTER //
// ./src/services/log.js